import { render, staticRenderFns } from "./SamChip.vue?vue&type=template&id=78ec357e&scoped=true&"
import script from "./SamChip.vue?vue&type=script&lang=js&"
export * from "./SamChip.vue?vue&type=script&lang=js&"
import style0 from "./SamChip.vue?vue&type=style&index=0&id=78ec357e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec357e",
  null
  
)

export default component.exports